import { Box, Typography, Container } from '@mui/material'
import { LANG } from '../../language/lang'
import MenuBox from './MenuBox';


const Footer = ({ isMobile }) => {
    return (
        <Box
            p={3}
            backgroundColor="background.paper"
            borderTop="1px solid"
            borderColor="divider"
            
        >
            <Container maxWidth={false} sx={{ maxWidth: '120rem', width: '100%', mx: 'auto' }}>
                <Box
                    display="flex"
                    flexDirection="column"

                    gap={2}
                >
                    <Box>
                        <MenuBox isMobile={isMobile} />
                    </Box>

                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Typography variant="body2" color="textSecondary">
                            © {new Date().getFullYear()} {LANG("FOOTER_COPYRIGHT")}
                        </Typography>
                    </Box>
                </Box>

            </Container>


        </Box>
    );
};

export default Footer;